import {ILeadModalPriceConversationConsultant} from "../types/ILeadModalPriceConversationConsultant";

import f1_72 from "../images/consultants/1_72x72.png";
import f1_144 from "../images/consultants/1_144x144.png";
import f1_216 from "../images/consultants/1_216x216.png";
import m1_72 from "../images/consultants/2_72x72.png";
import m1_144 from "../images/consultants/2_144x144.png";
import m1_216 from "../images/consultants/2_216x216.png";
import m2_72 from "../images/consultants/3_72x72.png";
import m2_144 from "../images/consultants/3_144x144.png";
import m2_216 from "../images/consultants/3_216x216.png";
import f2_72 from "../images/consultants/4_72x72.png";
import f2_144 from "../images/consultants/4_144x144.png";
import f2_216 from "../images/consultants/4_216x216.png";
import f3_72 from "../images/consultants/5_72x72.png";
import f3_144 from "../images/consultants/5_144x144.png";
import f3_216 from "../images/consultants/5_216x216.png";
import f4_72 from "../images/consultants/6_72x72.png";
import f4_144 from "../images/consultants/6_144x144.png";
import f4_216 from "../images/consultants/6_216x216.png";

const consultantList: ILeadModalPriceConversationConsultant[] = [
    {
        image: {s72: f1_72, s144: f1_144, s216: f1_216},
        gender: "female",
        fullName: "Monika Piotrowska"
    },
    {
        image: {s72: f2_72, s144: f2_144, s216: f2_216},
        gender: "female",
        fullName: "Ewa Zielińska"
    },
    {
        image: {s72: f3_72, s144: f3_144, s216: f3_216},
        gender: "female",
        fullName: "Katarzyna Wiśniewska"
    },
    {
        image: {s72: f4_72, s144: f4_144, s216: f4_216},
        gender: "female",
        fullName: "Marta Górska"
    },
    {
        image: {s72: m1_72, s144: m1_144, s216: m1_216},
        gender: "male",
        fullName: "Adam Lewandowski"
    },
    {
        image: {s72: m2_72, s144: m2_144, s216: m2_216},
        gender: "male",
        fullName: "Piotr Nowak"
    }
];

export function getRandomConsultant() {
    const randomIndex = Math.floor(Math.random() * consultantList.length);
    return consultantList[randomIndex];
}
import {ILeadModalPriceConversationConsultant} from "../types/ILeadModalPriceConversationConsultant";

import f1_72 from "../images/consultants/1_72x72.png";
import f1_144 from "../images/consultants/1_144x144.png";
import f1_216 from "../images/consultants/1_216x216.png";
import m1_72 from "../images/consultants/2_72x72.png";
import m1_144 from "../images/consultants/2_144x144.png";
import m1_216 from "../images/consultants/2_216x216.png";
import m2_72 from "../images/consultants/3_72x72.png";
import m2_144 from "../images/consultants/3_144x144.png";
import m2_216 from "../images/consultants/3_216x216.png";
import f2_72 from "../images/consultants/4_72x72.png";
import f2_144 from "../images/consultants/4_144x144.png";
import f2_216 from "../images/consultants/4_216x216.png";
import f3_72 from "../images/consultants/5_72x72.png";
import f3_144 from "../images/consultants/5_144x144.png";
import f3_216 from "../images/consultants/5_216x216.png";
import f4_72 from "../images/consultants/6_72x72.png";
import f4_144 from "../images/consultants/6_144x144.png";
import f4_216 from "../images/consultants/6_216x216.png";

const consultantList: ILeadModalPriceConversationConsultant[] = [
    {
        image: {s72: f1_72, s144: f1_144, s216: f1_216},
        gender: "female",
        fullName: "Monika Piotrowska"
    },
    {
        image: {s72: f2_72, s144: f2_144, s216: f2_216},
        gender: "female",
        fullName: "Ewa Zielińska"
    },
    {
        image: {s72: f3_72, s144: f3_144, s216: f3_216},
        gender: "female",
        fullName: "Katarzyna Wiśniewska"
    },
    {
        image: {s72: f4_72, s144: f4_144, s216: f4_216},
        gender: "female",
        fullName: "Marta Górska"
    },
    {
        image: {s72: m1_72, s144: m1_144, s216: m1_216},
        gender: "male",
        fullName: "Adam Lewandowski"
    },
    {
        image: {s72: m2_72, s144: m2_144, s216: m2_216},
        gender: "male",
        fullName: "Piotr Nowak"
    }
];

export function getRandomConsultant() {
    const randomIndex = Math.floor(Math.random() * consultantList.length);
    return consultantList[randomIndex];
}
